import axios from "axios";
import secureAxios from "../secure_axios";
import { toastErrorFromResponse } from "../../util/utilitarios";

const login = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/login/token/`
})

const baseUrlSecureAxios = 'login/token/'

async function ServGetTokenNTM(tokenSMS) {
    const response = await login.get('', { headers: { Authorization: `Bearer ${tokenSMS}` } });
    return response
}

async function ServGetTokenHttpOnly(tokenSMS, email, telefone) {
    const response = await login.get(
        'http-only',
        { 
            params: { email, telefone } ,
            headers: { Authorization: `Bearer ${tokenSMS}` }
        }
    );
    return response
}

async function servValidacaoToken() {
    const response = await secureAxios.get(baseUrlSecureAxios + 'validacao');
    return response
}

async function servInvalidarToken() {
    try {
        await login.get('invalidar');
        window.location.reload();
    } catch (error) {
        console.error(error);
        toastErrorFromResponse(error);
    }
}

export {
    ServGetTokenNTM,
    ServGetTokenHttpOnly,
    servValidacaoToken,
    servInvalidarToken
}